import { NetworkStatus } from '@apollo/client';
import { Box } from '@bechtel/gds';
import { useEffect } from 'react';
import { AuthLoader, ErrorRetry } from '~/components';
import { useAuthorizeUser } from '~/hooks/use-authorize-user';
import { ForbiddenAccess } from '../forbidden-access';

export const AuthRoute = ({ children }) => {
  const [getUserAccountByAuth, { loading, error, data, refetch, networkStatus, called }] = useAuthorizeUser();

  useEffect(() => {
    if (called) return;
    getUserAccountByAuth();
  });

  if (loading || networkStatus === NetworkStatus.refetch) {
    return <AuthLoader />;
  }

  if (!loading && error)
    return (
      <Box flexGrow={{ sm: 1 }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
        <ErrorRetry refetch={refetch} />
      </Box>
    );

  if (!data && called)
    return (
      <Box flexGrow={{ sm: ' 1' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
        <ForbiddenAccess />
      </Box>
    );
  return children;
};
